import React, { useEffect, useState } from 'react';
import { Col, DatePicker, Form, Input, Row, Select, Space } from 'antd';
import { Content } from 'antd/es/layout/layout';
import {
  CategoryCancel,
  CheckIcon,
  EyeIcon,
  FilterGoldIcon,
  FilterIcon,
} from 'assets/svg';
import { MainLayout } from 'components';
import Button from 'components/Button';
import useQueryParam from 'hooks/useQueryPrams';
import { useHistory } from 'react-router-dom';
import pageTitleStore from 'store/pageTitleStore';
import { ColumnsType } from 'antd/es/table';
import { Table } from 'antd/lib';
import { HocChangePagination } from 'utils/HocChangePagination';
import { useMutation } from 'react-query';
import ApprovalApi from 'apis/ApprovalApi';
import formatDateWithTime from 'utils/formatDateWithTime';
import { useForm } from 'antd/es/form/Form';
import { openNotificationWithIcon } from 'utils/notification';
import { useUser } from 'contexts/User';
import moment from 'moment';
import formatDateMDY from 'utils/formatDateMDY';

type FixedType = 'left' | 'right' | boolean;

export default function ApproveCategoryLits() {
  const history = useHistory();
  const queryParam = useQueryParam();
  const { user } = useUser();

  const { RangePicker } = DatePicker;
  const [form] = useForm();

  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(true);
  const [categoryApprovalList, setCategoryApprovalList] = useState<any>([]);
  const [searchDateFrom, setSearchDateFrom] = useState<any>();
  const [searchDateTo, setSearchDateTo] = useState<any>();
  const [total, setTotal] = useState<number>(0);
  const [searchParam, setSearchParam] = useState<any>();

  const page = parseInt(queryParam.get('page') + '') || 1;
  const page_size = parseInt(queryParam.get('page_size') + '') || 10;

  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  useEffect(() => {
    const pageTitle = 'PNJ - PMS';
    document.title = pageTitle;
    setTitle('Danh mục');
    setBreadcrumb([
      {
        title: (
          <p>
            <a href="/approve-category-list">Phê duyệt</a>
          </p>
        ),
      },
      {
        title: <a href="/approve-category-list">Danh mục</a>,
      },
    ]);

    getCategoryApprovalList();
  }, [page, page_size, searchParam, user]);

  const toggleFilter = () => {
    setIsOpenFilter(!isOpenFilter);
  };

  const onCancel = () => {
    form.resetFields();
    setSearchParam(undefined);
  };

  const params = {
    page,
    page_size,
    ...searchParam,
  };

  const {
    mutate: getCategoryApprovalList,
    isLoading: getCategoryApprovalListLoading,
  } = useMutation(
    ['categoryApprovalList'],
    () => ApprovalApi.getCategoryApprovalList(page, page_size, params),
    {
      onSuccess: (response: any) => {
        setCategoryApprovalList(response?.data);
        setTotal(response?.total);
      },
      onError: (error: any) => {
        console.log(error);
      },
    }
  );

  const ApproveOrDenyFunction = (
    status: string,
    description: string,
    POFcode: string
  ) => {
    // 1 == approve, 2 == deny
    ApprovalApi.approveOrDeny({ status, description }, POFcode)
      .then((res: any) => {
        switch (status) {
          case '1':
            if (res?.status === 'failure') {
              openNotificationWithIcon(
                'error',
                'Phê duyệt thất bại',
                res?.message
              );
            } else {
              openNotificationWithIcon('success', 'Phê duyệt thành công');
              setTimeout(() => {
                getCategoryApprovalList();
              }, 500);
            }
            break;
          case '2':
            if (res?.status === 'failure') {
              openNotificationWithIcon(
                'error',
                'Từ chối phê duyệt thất bại',
                res?.message
              );
            } else {
              openNotificationWithIcon(
                'success',
                'Từ chối phê duyệt thành công'
              );
              setTimeout(() => {
                getCategoryApprovalList();
              }, 500);
            }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onFinish = (values: any) => {
    const filteredData = Object.fromEntries(
      Object.entries(values).filter(([_, value]) => value !== undefined)
    );
    const stringifiedData: { [key: string]: any } = {};

    Object.keys(filteredData).forEach((key) => {
      if (key == 'create_date' && filteredData[key]) {
        const ranges: any = filteredData[key];
        stringifiedData['from'] = ranges[0].format('MM/DD/YYYY');
        stringifiedData['to'] = ranges[1].format('MM/DD/YYYY');
      } else {
        stringifiedData[key] = String(filteredData[key]);
      }
    });
    setSearchParam(stringifiedData);
  };

  function onChange(dates: any, dateStrings: any) {
    setSearchDateFrom(dateStrings[0]);
    setSearchDateTo(dateStrings[1]);
  }

  const onChangeInput = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (e.target.value === '') {
      setSearchParam({ ...searchParam, category_name_code: undefined });
    }
  };

  const IsApprover = (approver: any) => {
    if (approver === null) {
      return false;
    } else {
      const approverArr = (approver || []).split(',');
      const isUserExist = approverArr.findIndex((item: any) => {
        return item === user?.fullName;
      });

      if (isUserExist === -1) {
        return false;
      } else return true;
    }
  };

  const checkRulesAndRenderButtons = (record: any) => {
    if (record?.approve_status !== 0) {
      return (
        <div className="flex justify-around">
          <button
            onClick={() => {
              history.push(`/approve-category-detail/${record?.id}`);
            }}
          >
            <EyeIcon />
          </button>
          <button disabled style={{ opacity: '0.3' }}>
            <CheckIcon />
          </button>
          <button disabled style={{ opacity: '0.3' }}>
            <CategoryCancel />
          </button>
        </div>
      );
    } else {
      if (IsApprover(record?.approver_name) === false) {
        return (
          <div className="flex justify-around">
            <button
              onClick={() => {
                history.push(`/approve-category-detail/${record?.id}`);
              }}
            >
              <EyeIcon />
            </button>
            <button disabled style={{ opacity: '0.3' }}>
              <CheckIcon />
            </button>
            <button disabled style={{ opacity: '0.3' }}>
              <CategoryCancel />
            </button>
          </div>
        );
      } else {
        return (
          <div className="flex justify-around">
            <button
              onClick={() => {
                history.push(`/approve-category-detail/${record?.id}`);
              }}
            >
              <EyeIcon />
            </button>
            <button
              onClick={() => {
                ApproveOrDenyFunction('1', '', record?.pof_code);
              }}
            >
              <CheckIcon />
            </button>
            <button
              onClick={() => {
                ApproveOrDenyFunction('2', '', record?.pof_code);
              }}
            >
              <CategoryCancel />
            </button>
          </div>
        );
      }
    }
  };

  // const checkRulesAndRenderButtons = (record: any) => {
  //   if (user?.fullName === record?.create_by) {
  //     return (
  //       <div className="flex justify-around">
  //         <button
  //           onClick={() => {
  //             history.push(`/approve-category-detail/${record?.id}`);
  //           }}
  //         >
  //           <EyeIcon />
  //         </button>
  //         <button disabled style={{ opacity: '0.3' }}>
  //           <CheckIcon />
  //         </button>
  //         <button disabled style={{ opacity: '0.3' }}>
  //           <CategoryCancel />
  //         </button>
  //       </div>
  //     );
  //   } else {
  //     if (record?.approve_status !== 0) {
  //       return (
  //         <div className="flex justify-around">
  //           <button
  //             onClick={() => {
  //               history.push(`/approve-category-detail/${record?.id}`);
  //             }}
  //           >
  //             <EyeIcon />
  //           </button>
  //           <button disabled style={{ opacity: '0.3' }}>
  //             <CheckIcon />
  //           </button>
  //           <button disabled style={{ opacity: '0.3' }}>
  //             <CategoryCancel />
  //           </button>
  //         </div>
  //       );
  //     } else {
  //       if (IsApprover(record?.approver_name) === false) {
  //         return (
  //           <div className="flex justify-around">
  //             <button
  //               onClick={() => {
  //                 history.push(`/approve-category-detail/${record?.id}`);
  //               }}
  //             >
  //               <EyeIcon />
  //             </button>
  //             <button disabled style={{ opacity: '0.3' }}>
  //               <CheckIcon />
  //             </button>
  //             <button disabled style={{ opacity: '0.3' }}>
  //               <CategoryCancel />
  //             </button>
  //           </div>
  //         );
  //       } else {
  //         return (
  //           <div className="flex justify-around">
  //             <button
  //               onClick={() => {
  //                 history.push(`/approve-category-detail/${record?.id}`);
  //               }}
  //             >
  //               <EyeIcon />
  //             </button>
  //             <button
  //               onClick={() => {
  //                 ApproveOrDenyFunction('1', '', record?.pof_code);
  //               }}
  //             >
  //               <CheckIcon />
  //             </button>
  //             <button
  //               onClick={() => {
  //                 ApproveOrDenyFunction('2', '', record?.pof_code);
  //               }}
  //             >
  //               <CategoryCancel />
  //             </button>
  //           </div>
  //         );
  //       }
  //     }
  //   }
  // };

  const columns: ColumnsType<any> = [
    {
      title: 'STT',
      dataIndex: 'id',
      width: 60,
      render: (text, record, index) => index + 1 + page_size * (page - 1),
    },
    {
      title: 'Mã danh mục',
      dataIndex: 'pof_code',
      width: 180,
    },
    {
      title: 'Loại danh mục',
      dataIndex: 'pof_type_name',
      width: 160,
    },
    {
      title: 'Tên danh mục',
      dataIndex: 'pof_name',
      width: 200,
    },
    {
      title: 'Trạng thái phê duyệt',
      width: 175,
      render: (text, record, index) => {
        switch (record?.approve_status) {
          case 0:
            return 'Chờ duyệt';
          case 1:
            return 'Đã phê duyệt';
          case 2:
            return 'Từ chối';
          case null:
            return '-';
        }
      },
    },
    {
      title: 'Người khai báo',
      dataIndex: 'created_by',
      width: 160,
    },
    {
      title: 'Phòng ban',
      dataIndex: 'department_name',
      width: 250,
    },
    {
      title: 'Đơn vị phát hành',
      dataIndex: 'division_name',
      width: 250,
    },
    {
      title: 'Công ty phát hành',
      dataIndex: 'company',
      width: 200,
    },
    {
      title: 'Đặt hàng theo ni',
      width: 150,
      render: (text, record, index) =>
        record?.allow_order_ni === true ? 'Có' : 'Không',
    },
    {
      title: 'Ngày tạo',
      width: 150,
      render: (text, record, index) => formatDateWithTime(record?.created_date),
    },
    {
      title: 'Ngày hết hạn',
      width: 150,
      render: (text, record, index) => formatDateWithTime(record?.expired_date),
    },
    {
      title: 'Người phê duyệt',
      width: 175,
      render: (text, record, index) =>
        record?.approver_name ? record?.approver_name : '-',
    },
    // {
    //   title: 'Thời gian yêu cầu',
    //   width: 175,
    //   render: (text, record, index) =>
    //     formatDateWithTime(record?.send_approve_date),
    // },
    {
      title: 'Ngày gửi phê duyệt',
      width: 175,
      render: (text, record, index) =>
        formatDateWithTime(record?.send_approve_date),
    },
    {
      title: 'Ngày phê duyệt',
      width: 175,
      render: (text, record, index) => formatDateWithTime(record?.approve_date),
    },
    {
      fixed: 'right' as FixedType,
      width: 120,
      align: 'center',
      render: (_: any, record: any) => checkRulesAndRenderButtons(record),
    },
  ];

  return (
    <MainLayout isLoading={getCategoryApprovalListLoading}>
      <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        justify="end"
        className="mb-5"
      >
        <Space>
          <Col className="flex justify-end">
            <Button
              bgColor={'bg-white'}
              color={`${
                isOpenFilter ? 'text-primary-50' : 'text-secondary-50'
              }`}
              border={`${
                isOpenFilter ? 'border-primary-50' : 'border-secondary-50'
              }`}
              onClick={toggleFilter}
            >
              {isOpenFilter ? <FilterIcon /> : <FilterGoldIcon />}
              Lọc
            </Button>
          </Col>
        </Space>
      </Row>

      <Form
        layout="vertical"
        className={`items-center ${isOpenFilter ? '' : 'hidden'}`}
        autoComplete="off"
        form={form}
        onFinish={onFinish}
      >
        <Content>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={6}>
              <Form.Item name="key_word" label="Tìm kiếm theo từ khoá">
                <Input
                  size="large"
                  allowClear={true}
                  placeholder="Tìm kiếm theo tên, mã danh mục"
                />
              </Form.Item>
            </Col>
            <Col className="" span={6}>
              <Form.Item label="Loại danh mục" name={'pof_type'}>
                <Select
                  allowClear={true}
                  placeholder="Tìm kiếm theo loại danh mục"
                  size="small"
                >
                  <Select.Option value={'trial'}>Hàng mới</Select.Option>
                  <Select.Option value={'other'}>Ngoài danh mục</Select.Option>
                  <Select.Option value={'suggest'}>Khuyến nghị</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col className="" span={6}>
              <Form.Item label="Ngày gửi phê duyệt" name={'create_date'}>
                <RangePicker
                  style={{ height: '40px' }}
                  name="approve_status"
                  placeholder={['dd/mm/yyyy', 'dd/mm/yyyy']}
                  allowClear={true}
                  format={'DD/MM/YYYY'}
                />
              </Form.Item>
            </Col>
            <Col className="" span={6}>
              <Form.Item label="Trạng thái phê duyệt" name={'status'}>
                <Select
                  allowClear={true}
                  placeholder="Tìm kiếm theo trạng thái"
                  size="small"
                >
                  <Select.Option value={0}>Chờ duyệt</Select.Option>
                  <Select.Option value={1}>Đã phê duyệt</Select.Option>
                  <Select.Option value={2}>Từ chối</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="end">
            <Col className="flex justify-end" span={8}>
              <Space>
                <Button
                  bgColor={'bg-white'}
                  color={'text-primary-50'}
                  border={'border-primary-50'}
                  onClick={onCancel}
                >
                  Hủy
                </Button>
                <Button type="submit">Tìm kiếm</Button>
              </Space>
            </Col>
          </Row>
        </Content>
      </Form>

      <Content className="mt-4 main-content">
        <Table
          rowKey={(record) => record.id}
          columns={columns}
          className="customTable"
          dataSource={categoryApprovalList}
          scroll={{ x: 958 }}
          loading={getCategoryApprovalListLoading}
          pagination={{
            className: 'flex items-center',
            current: page,
            pageSize: page_size,
            total: total,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
            onChange: HocChangePagination(history),
          }}
        />
      </Content>
    </MainLayout>
  );
}
